import { Enum, EnumType } from 'ts-jenum';
import { OpenDynamicLinkAutoOpenTrigger } from 'src/generated/signalR/open-dynamic-link-auto-open-trigger';

@Enum<OpenDynamicLinkAutoOpenTriggersEnum>('value')
export class OpenDynamicLinkAutoOpenTriggersEnum extends EnumType<OpenDynamicLinkAutoOpenTriggersEnum>() {
   static readonly INBOUND_CALL_OFFERED = new OpenDynamicLinkAutoOpenTriggersEnum(
      OpenDynamicLinkAutoOpenTrigger.InboundCallOffered,
      'user_actions.types.open_dynamic_link.settings.auto_open_triggers.inbound_call_offered',
      'user_actions.types.open_dynamic_link.settings.auto_open_triggers.groups.inbound_calls'
   );

   static readonly INBOUND_CALL_ANSWERED = new OpenDynamicLinkAutoOpenTriggersEnum(
      OpenDynamicLinkAutoOpenTrigger.InboundCallAnswered,
      'user_actions.types.open_dynamic_link.settings.auto_open_triggers.inbound_call_connected',
      'user_actions.types.open_dynamic_link.settings.auto_open_triggers.groups.inbound_calls'
   );

   static readonly INBOUND_ANSWERED_CALL_IDLE = new OpenDynamicLinkAutoOpenTriggersEnum(
      OpenDynamicLinkAutoOpenTrigger.InboundAnsweredCallIdle,
      'user_actions.types.open_dynamic_link.settings.auto_open_triggers.inbound_connected_call_idle',
      'user_actions.types.open_dynamic_link.settings.auto_open_triggers.groups.inbound_calls'
   );

   static readonly OUTBOUND_CALL_DIALED = new OpenDynamicLinkAutoOpenTriggersEnum(
      OpenDynamicLinkAutoOpenTrigger.OutboundCallDialed,
      'user_actions.types.open_dynamic_link.settings.auto_open_triggers.outbound_call_dialed',
      'user_actions.types.open_dynamic_link.settings.auto_open_triggers.groups.outbound_calls'
   );

   static readonly OUTBOUND_CALL_CONNECTED = new OpenDynamicLinkAutoOpenTriggersEnum(
      OpenDynamicLinkAutoOpenTrigger.OutboundCallConnected,
      'user_actions.types.open_dynamic_link.settings.auto_open_triggers.outbound_call_connected',
      'user_actions.types.open_dynamic_link.settings.auto_open_triggers.groups.outbound_calls'
   );

   static readonly OUTBOUND_CONNECTED_CALL_IDLE = new OpenDynamicLinkAutoOpenTriggersEnum(
      OpenDynamicLinkAutoOpenTrigger.OutboundConnectedCallIdle,
      'user_actions.types.open_dynamic_link.settings.auto_open_triggers.outbound_connected_call_idle',
      'user_actions.types.open_dynamic_link.settings.auto_open_triggers.groups.outbound_calls'
   );

   private constructor(public value: OpenDynamicLinkAutoOpenTrigger, public translationKey: string, public groupNameTranslationKey: string) {
      super();
   }
}
